export const SET_SNACKBAR = 'SET_SNACKBAR'
export const SET_TIMEOUT = 'SET_TIMEOUT'
